import { render, staticRenderFns } from "./xsgjList.vue?vue&type=template&id=d279ed08&scoped=true&"
import script from "./xsgjList.vue?vue&type=script&lang=js&"
export * from "./xsgjList.vue?vue&type=script&lang=js&"
import style0 from "./xsgjList.vue?vue&type=style&index=0&id=d279ed08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d279ed08",
  null
  
)

export default component.exports